import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { getMe } from '@/api/auth';
import { useUserStore } from './user';

export const usePermissionStore = defineStore('permission', () => {
    const loaded = ref(false);
    const permissions = ref([]);

    const hasPermission = (perm) => {
        if (!perm) return true;
        const userStore = useUserStore();
        if (userStore.userInfo?.userType === 1) return true; // 超级管理员
        return permissions.value.includes(perm);
    };

    const hasAnyPermission = (perms) => {
        if (!perms || perms.length === 0) return true;
        return perms.some(p => hasPermission(p));
    };

    async function loadPermissions() {
        const userStore = useUserStore();
        if (!userStore.token) {
            loaded.value = false;
            return;
        }
        try {
            const res = await getMe();
            permissions.value = res.permissions || [];
            // 刷新页面后 userInfo 也丢失了，一并恢复，
            // 否则超管的 userType===1 判断会失效
            if (!userStore.userInfo) {
                userStore.userInfo = res;
            }
            loaded.value = true;
        } catch {
            loaded.value = false;
            throw new Error('加载权限失败');
        }
    }

    return {
        loaded,
        permissions,
        hasPermission,
        hasAnyPermission,
        loadPermissions
    };
});
